import gsap from "gsap";

export default class {
    constructor() {
        this.Init();
        this.animateMainVisual();
    }

    Init() {
        const campaign = document.querySelector("#p-campaign");
        if (campaign) {
            document.querySelectorAll(".slide-elem").forEach((el) => {
                let startX = parseFloat(el.dataset.start) || 100;
                let resetX = 110;

                let mediaQuery = window.matchMedia("(max-width: 575.98px)");
                let endX = mediaQuery.matches ? -48.5 : -35;

                mediaQuery.addEventListener("change", (e) => {
                    endX = e.matches ? -48.5 : -35;
                });

                gsap.set(el, { x: `${startX}vw` });

                let firstDuration = parseFloat(el.dataset.speed) || ((startX - endX) * 0.25);
                let loopDuration = ((resetX - endX) / (startX - endX)) * firstDuration;

                gsap.to(el, {
                    x: () => `${endX}vw`,
                    duration: firstDuration,
                    ease: "linear",
                    onComplete: () => restartAnimation(el, loopDuration),
                });

                function restartAnimation(el, duration) {
                    gsap.set(el, { x: `${resetX}vw` });

                    gsap.to(el, {
                        x: () => `${endX}vw`,
                        duration: duration,
                        ease: "linear",
                        onComplete: () => restartAnimation(el, duration),
                    });
                }
            });
        }
    }

    animateMainVisual() {
        const mainVisual = document.querySelector(".p-campaign__main__catch");
        const bnr = document.querySelector(".p-campaign__main__bnr");

        if (mainVisual) {
            const topText = mainVisual.querySelector(".top");
            const bottomText = mainVisual.querySelector(".btm");

            this.createMask(topText);
            this.createMask(bottomText);

            const topMask = topText.querySelector(".mask");
            const bottomMask = bottomText.querySelector(".mask");

            gsap.set([topMask, bottomMask], { left: "0" });

            gsap.to(topMask, {
                left: "100%",
                duration: 1,
                ease: "power3.out",
                delay: 0.3,
            });

            gsap.to(bottomMask, {
                left: "100%",
                duration: 1,
                ease: "power3.out",
                delay: 0.6,
            });
        }

        if (bnr) {
            gsap.set(bnr, { opacity: 0, rotate: 1080, scsle: 1.2 });

            gsap.to(bnr, {
                opacity: 1,
                rotate: 10,
                scale: 1,
                duration: 1,
                ease: "power2.out",
                delay: 1,
            });
        }
    }

    createMask(element) {
        if (!element.querySelector(".mask")) {
            const mask = document.createElement("div");
            mask.classList.add("mask");
            element.appendChild(mask);
        }
    }
}
